export const RoutePathnames = {
  HOME: '/',
  ACCOUNTS: '/accounts',
  ACCOUNT_COURSES: '/accounts/:accountId/courses',
  SYNC_STATUS: '/sync-status'
};

export const ACCOUNTS_COURSES_PATTERN = /\/accounts\/(\w|-)+\/courses$/;
